import React from 'react';
import { Avatar } from '@mui/material';
import AvatarWithFallback from '@avatar/components/AvatarWithFallback';
import Icon from '@ui/Icon';
import { StudioClipProps } from '../../StudioClip/StudioClip';
import { CompleteProps } from '../../StudioClip/States/Complete';
import { variantDisplayText } from '../utils/avatar';

const AvatarContainer = ({
  clip,
  classes,
}: {
  clip: StudioClipProps['clip'];
  classes: CompleteProps['studioClipCompleteClasses']['classes'];
}) => {
  const variantDisplayLabel = variantDisplayText(clip.actor.variant);
  const avatarLabel = `${clip.actor.name} - ${variantDisplayLabel}`;
  return (
    <div className={classes.avatarContainer}>
      {clip.combinedFrom ? (
        <Avatar
          alt="combined clip"
          classes={{ colorDefault: classes.avatarCombined }}
        >
          <Icon type="combineClips" fontSize="small" />
        </Avatar>
      ) : (
        <AvatarWithFallback src={clip.actor.image} title={avatarLabel} />
      )}
    </div>
  );
};

export default AvatarContainer;
